/** Cognito's messages are usable as-is; its exception class names are not. */
export function describeAuthError(
  error: unknown,
  fallback = "Something went wrong.",
): string {
  if (!(error instanceof Error)) return fallback;
  switch (error.name) {
    case "NotAuthorizedException":
    case "UserNotFoundException":
      return "That email and password do not match.";
    case "UsernameExistsException":
      return "There is already an account with that email. Sign in instead.";
    case "UserNotConfirmedException":
      return "Please confirm your email first — check your inbox for the link.";
    case "CodeMismatchException":
      return "That confirmation link is not valid. Request a new one from sign-in.";
    case "ExpiredCodeException":
      return "That confirmation link has expired. Request a new one from sign-in.";
    case "TooManyRequestsException":
    case "LimitExceededException":
      return "Too many attempts. Wait a minute and try again.";
    case "InvalidPasswordException":
    case "InvalidParameterException":
      return error.message;
    default:
      return error.message || fallback;
  }
}
